<template>
  <main id="vendors-list" class="site-main">
    <div class="grid-container">
      <div class="page-header grid-x grid-padding-x align-middle">
        <div class="cell auto">
          <h1 class="page-header__title">Vendor Accounts</h1>
        </div>

        <div class="cell auto text-right">
          <span class="icon-action" @click="exportAccounts">
            <i class="far fa-arrow-to-bottom"></i> <span>Export</span>
          </span>
        </div>
      </div>

      <div class="panel">
        <div class="panel__content">
          <h3>To add Vendor login accounts please follow these steps.</h3>

          <p>You now have the option to white label the vendor portal. It will
            load under your own store domain and  you may change the branding
            for it by going to the
            <router-link :to="{ name: 'settingsGeneral' }">settings page</router-link>.</p>

          <ol>
            <li>Have your vendors go to this link and register:
              <a :href="'https://' + $store.state.shop.domain + '/apps/vendor-portal/'"
                 target="_blank">https://{{ $store.state.shop.domain }}/apps/vendor-portal/</a></li>
            <li>Approve their account as it appears on this screen. You will need to link them to a vendor
              from your store.</li>
            <li>They will now be able to login from the same link they requested their account.</li>
          </ol>
        </div>
      </div>

      <div class="panel no-padding">
        <searchBar placeholder="Search vendors" @sort="sort"
                   :value="searchValue"
                   @search="search"></searchBar>

        <div :class="['loading-area', loading ? 'loading' : '']">
          <div :class="['loading-area__content', loading ? 'loading' : '']">
            <pagination :prev="prev" :next="next" :start="start" :end="end"
                        :total="total" @paginate="paginate"></pagination>

            <tableList class="no-hover" :header="tableHeader" :data="tableData"
                       :loading="loading"
                       @sort="orderBy" @callback="callback"></tableList>

            <pagination :prev="prev" :next="next" :start="start" :end="end"
                        :total="total" @paginate="paginate"></pagination>
          </div>
        </div>
      </div>
    </div>

    <transition name="fade">
      <editAccounts v-if="editVendor" :accountUserName="vendorSignupName"
                    :accountVendorList="accountVendorList"
                    :accountApproval="vendorApproval"
                    :accountID="accountID"
                    @done="cancelEdit" @save="saveEdit"></editAccounts>
    </transition>
  </main>
</template>

<script>
import client from '@/mixins/client'
import paginationUtils from '@/mixins/paginationUtils'
import payout from '@/globals/payout'
import editAccounts from '@/globals/editAccounts'

export default {
  name: 'accountsList',
  mixins: [client, paginationUtils],
  components: {
    payout,
    editAccounts
  },
  data: function () {
    return {
      action: '/vendors/shop-vendor-accounts/?expand=vendors',
      sort: 'name',
      editVendor: false,
      vendorSignupName: '',
      accountID: 0,
      accountVendorList: [],
      vendorNames: [],
      vendorApproval: '',
      shortDomain: '',
      tableHeader: {
        currentSort: 'name',
        data: [
          {
            label: 'Name',
            sort: 'name',
            class: 'full'
          },
          {
            label: 'Email',
            sort: 'commission_due',
            class: 'full',
            sortStart: '-'
          },
          {
            label: 'Vendors',
            sort: 'commission_paid',
            class: 'medium',
            sortStart: '-'
          },
          {
            label: 'Status',
            sort: 'approved',
            sortStart: '-'
          },
          {
            label: '',
            class: 'medium'
          }
        ]
      },
      tableData: []
    }
  },
  methods: {
    exportAccounts () {
      this.loading = true
      let endpoint = '/vendors/signups/'
      let data = {
        ordering: 'name',
        page_size: 1000,
        format: 'csv'
      }

      this.request('get', endpoint, data).then((response) => {
        let downloadLink = document.createElement('a')

        downloadLink.href = response
        downloadLink.target = '_blank'

        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)

        this.loading = false
      })
    },
    buildTable () {
      let isApproved = 'Disabled'
      let approvalStatus = 'alert'
      this.tableData = []
      for (let i = 0; i < this.data.length; i++) {
        let vendorData = this.data[i]
        if (vendorData.approved === true) {
          isApproved = 'Active'
          approvalStatus = 'success'
        } else {
          isApproved = 'Disabled'
          approvalStatus = 'alert'
        }

        let vendors = ''
        if (vendorData.vendors && vendorData.vendors.length > 0) {
          for (let i = 0; i < vendorData.vendors.length; i++) {
            let url = '/vendors/' + vendorData.vendors[i].id + '/'
            vendors += '<a href="' + url + '"><div>' + vendorData.vendors[i].name + '</div></a>'
          }
        } else {
          vendors = 'No Vendors Here'
        }

        let row = {
          post: this.data[i].id,
          data: [
            {
              value: this.data[i].vendor_signup_name,
              class: 'full'
            },
            {
              value: vendorData.vendor_signup_user_email,
              class: 'focus-text full email'
            },
            {
              value: vendors,
              class: 'medium'
            },
            {
              value: isApproved,
              span: 'label ' + approvalStatus
            }
          ]
        }
        row.data.push({
          value: '<button class="button--small">Edit Account</button>',
          class: 'medium',
          callback: 'editAccount',
          callbackArgs: [this.data[i].vendor_signup_name, this.data[i].vendors,
            this.data[i].vendor_signup_id, this.data[i].approved]
        })
        this.tableData.push(row)
      }
    },
    editAccount: function (vendorName, vendorList, id, approved) {
      this.editVendor = true
      this.accountID = id
      this.vendorSignupName = vendorName
      this.accountVendorList = vendorList
      this.vendorApproval = approved
    },
    cancelEdit () {
      this.editVendor = false
    },
    saveEdit () {
      this.editVendor = false
      this.getData()
    }
  },
  mounted () {
    this.shortDomain = this.$store.state.shop.myshopify_domain.replace('.myshopify.com', '')
    this.getData()
  }
}
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/mixins';

.email {
  white-space: nowrap;
}

</style>



// WEBPACK FOOTER //
// src/pages/accounts/list.vue